<ui-modal
  class="app-options-portfolio-spots"
  [isOpened]="isOpened"
  modalTitle="Options Portfolio"
  (isOpenedChange)="modalChanged($event)"
>
  <div
    *ngIf="currencyPairs.length; else noSpots"
    class="app-options-portfolio-spots__table-container"
  >
    <form [formGroup]="legForm">
      <table ui-table>
        <thead>
          <tr>
            <th>Currency Pair</th>
            <th>Spot</th>
          </tr>
        </thead>
        <tbody>
          <ng-container formArrayName="optionsPortfolioSpots">
            <tr
              *ngFor="let item of portfolioSpots; let i = index"
              [formGroupName]="i"
            >
              <td class="cross">{{ currencyPairs[i] }}</td>
              <td class="spot">
                <input
                  type="number"
                  class="input-cell"
                  (input)="textboxChange($event.target)"
                  (blur)="spotBlur($event.target, item, currencyPairs[i])"
                  [formControlName]="currencyPairs[i]"
                  [readOnly]="item.controls[currencyPairs[i]].pending"
                />
                <span
                  *ngIf="item.controls[currencyPairs[i]].pending"
                  class="spinner spinner-sm spinner-inverse"
                >
                </span>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </form>
  </div>
  <ng-template #noSpots>
    <div class="app-options-portfolio-spots__no-spots">
      No Portfolio Spots Available
    </div>
  </ng-template>
</ui-modal>
